<template>
  <vs-card>
    <List :subjectPermission="subjectPermission"></List>
  </vs-card>
</template>

<script>
import List from '../../lists/ListApolices.vue';
export default {
  data() {
    return {
      subjectPermission: 'Apólice',
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
